import ApiService from "@/core/services/api.service"
import { Models, Services } from "@ekkosense/predict-client-api"
import { Base } from "./Base"
import { NRef } from "@/client-store/common/NRef"

/**
 *
 */
export class CoolingMeterPoint extends Base<Models.CoolingMeterPointModel> {
    /**
     *
     * @returns
     */
    private getService() {
        return ApiService.getNamedService<Services.CoolingMeterPointService>("CoolingMeterPointService")
    }
    async add(): Promise<NRef<Models.CoolingMeterPointModel>> {
        const service = await this.getService()
        const [nodeOut] = await service.addCoolingMeterPoint(this.node)
        this.node = nodeOut
        await this.connect()
        return nodeOut
    }
    async connect(): Promise<any> {
        const siteConfiguration = await this.node.getSiteConfiguration()
        siteConfiguration?.addMeterPoints([this.node])
    }
    async disconnect(): Promise<any> {
        const siteConfiguration = await this.node.getSiteConfiguration()
        siteConfiguration?.removeMeterPoints([this.node])
    }
    async remove(): Promise<any> {
        const service = await this.getService()
        await service.removeCoolingMeterPoint(this.node)
        return this.disconnect()
    }
    async update(): Promise<any> {
        const service = await this.getService()
        await service.updateCoolingMeterPoint(this.node)
    }
}